/*
 ** code状态码
 */
export enum CommonEmptyCardCode {
  NOT_IN_MVP_AREA = 201003213, // 不在MVP区域
  IN_MVP_AREA_BUT_NO_SUPPLY = 201003206, // 在MVP区域但无供给/金刚全部无供给
  // 同枚举值为业务需求说明
  KINGKONG_NO_SUPPLY = 201003207, // 金刚页的201003207：单个金刚无供给
  NO_DISCOUNT_SUPPLY = 201003207, // 店铺页的201003207：店铺有一般供给无优惠供给
}

/*
 ** 页面来源
 */
export enum CommonEmptyCardPageSource {
  HOME_PAGE = 0, // 首页
  KINGKONG = 1, // 金刚落地页
  FIXED_PRICE = 2, // 一人食落地页
  SHOP_LANDING_PAGE = 3, // 店铺专区落地页
}
